import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BaseService } from '../../Services/base.service';
import { ServiceLocator } from '../../Services/locator.service';
import { BizDatatableComponent } from '../biz-datatable/biz-datatable.component';
import { Enum } from '../config';

@Component({
    selector: 'leather-lookup',
    templateUrl: 'leather-lookup.component.html',
})
export class LeatherLookupComponent implements OnInit, AfterViewInit {
    @Input() defaultValues: any[] = [];
    @Input() rows: any[] = [];
    @Input() headerHeight: number = 30;
    @Input() returnObject: any = {};
    @Input() scrollbarH: boolean = true;
    @Input() footerHeight: number = 50;
    @Input() limit: number = 10;
    @Input() hideEdit: boolean = true;
    @Input() hideView: boolean = false;
    @Input() hideDelete: boolean = true;
    @Input() columnMode: string = Enum.ColumnMode.standard;
    @Input() pagination: boolean = true;
    @Input() caption: string = "Leather";
    @Input() rowIndex: any;
    itemOptionsOrders: any;
    itemOrder: any;
    buttonDisabled = false;
    buttonState = '';
    // @Input() type: number = 1;

    @Input() public selectedRows: any[] = [];

    @ViewChild('lookupModal') lookupModal: TemplateRef<any>;
    @ViewChild('table') table: BizDatatableComponent;

    public _columns: any[] = [];
    public _type: number = 4;
    modalRef: any;
    @Input()
    get columns(): any {

        return this._columns;
    }
    set columns(columns: any) {

        this._columns = columns;
    }
    @Input()
    get type(): any {
        return this._type;
    }
    set type(type: any) {
        this._type = type;
        if (type === 5 && this._columns.length > 0) {
            let selectCol = {
                prop: 'selected',
                name: '',
                sortable: false,
                canAutoResize: false,
                draggable: false,
                resizable: false,
                headerCheckboxable: true,
                checkboxable: true,
                width: 50
            };
            this._columns.splice(0, 0, selectCol);
        }
    }

    private baseService: any;

    constructor(private modalService: BsModalService) {
        this.baseService = ServiceLocator.injector.get(BaseService);
    }

    @Output()
    onClick: EventEmitter<any> = new EventEmitter<any>();

    articlelist: any[] = [];
    head: any[] = [];
    articleParams: any[] = [];
    lookupForm = new FormGroup({
        article: new FormControl(''),
    });
    debugger
    async getAllLeather(tType, FKArticleID, filed, value) {
        let val = 'tType=' + tType + '&FKArticleID=' + FKArticleID + '&filed=' + filed + '&value=' + value;
        await this.baseService.get('SalesModelsLeather', 'getAllLeather', val, 'apiURL').then(o => {
            if (o && o.length && o.length > 0) {
                this.rows = o;
            }
        })
    }

    async ngOnInit() {
        debugger
        this.itemOrder = { label: 'Leather Name', value: 'leather' };
        this.itemOptionsOrders = [
            { label: 'ID', value: 'id' },
            { label: 'Leather Name', value: 'leather' },
        ];
        this.articleParams = [{ name: 'filed', value: 'name' }, { name: 'value', value: 'value' }]
    }

    async ngAfterViewInit() { }

    async open() {
        debugger
        this.columns = [{ prop: 'id', name: 'ID', width: 100 }, { prop: 'leather', name: 'Leather Name', width: 200 }];

        setTimeout(() => {
            this.caption = this.caption && this.caption !== "" ? this.caption : 'Lookup'
            this.modalRef = this.modalService.show(this.lookupModal, {
                animated: true,
                backdrop: 'static',
                class: 'modal-lg',
            });

        }, 0);

    }

    @Input()
    public LookupId: String = "";

    Click(row) {
        debugger
        debugger
        let obj = {
            grid: this.table,
            row: row,
            data: this.rows
        }

        if (obj) {

            if (this.modalRef)
                this.modalRef.hide()
            this.onClick.emit(obj);
        }
    }

    onSelection(selection) {
        debugger
        if (selection) {

        }
    }

    save() {
        debugger
        if (this.selectedRows) {

            this.modalRef.hide();
            return this.selectedRows;

        }
    }

    itemsPerPageChange(e) {
        debugger
    }
    tempData: any[] = []
    async searchByButton(obj) {
        debugger
        if (obj && obj.value) {
            
            if (this.lookupForm.controls['article'].value)
                await this.getAllLeather(2, this.lookupForm.controls['article'].value, obj.item.value, obj.value)
            else
                await this.getAllLeather(3, 0, obj.item.value, obj.value)
        }

    }
    searchKeyUp(obj): void {
        debugger
        const val = obj.event.target.value;

        if (val === "" && this.tempData.length > 0) {

            this.rows = [...this.tempData]
            this.tempData = [];
        }

        if (this.tempData.length === 0) this.tempData = this.rows;

        this.rows = this.rows.filter(i => i[obj.item.value].toString().toLowerCase().indexOf(val.toString().toLowerCase()) !== - 1);

    };

}

export interface LookupResult {
    lookupId: string;
    data: any;
}
